import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer token from localStorage as fallback (cookies work primarily)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("td_token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function fileUrl(path) {
  if (!path) return "";
  if (path.startsWith("http") || path.startsWith("data:")) return path;
  if (path.startsWith("/api/")) return `${BACKEND_URL}${path}`;
  return `${API}/files/${path}`;
}

export function buildWhatsAppUrl(phone, message) {
  const cleanPhone = (phone || "").replace(/\D/g, "");
  const encoded = encodeURIComponent(message || "");
  return `https://wa.me/${cleanPhone}?text=${encoded}`;
}

export function productWhatsAppMessage(productName) {
  return `Halo Teknik Diesel Indonesia, saya melihat ${productName} di teknikdiesel.com. Saya ingin mendapatkan informasi mengenai harga, spesifikasi, penggunaan/kondisi, dan ketersediaan produk ini. Terima kasih.`;
}

export function generalWhatsAppMessage() {
  return `Halo Teknik Diesel Indonesia, saya menemukan website teknikdiesel.com dan ingin bertanya mengenai produk.`;
}

export function sparePartWhatsAppMessage() {
  return `Halo Teknik Diesel Indonesia, saya ingin bertanya ketersediaan spare part.`;
}

/* =====================================================================
 * Null-safe helpers for product data.
 * Fixes: `TypeError: Cannot read properties of undefined (reading 'toLowerCase')`
 * =====================================================================
 */
export const normalizeText = (value) => String(value ?? "").trim().toLowerCase();

export const slugSegment = (value) =>
  normalizeText(value).replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "item";

/** Normalize a product-shaped object for safe frontend consumption.
 *  Supports legacy field names (name → product_name, status → stock_status,
 *  description → short_description) so older records don't crash the UI. */
export function normalizeProduct(raw) {
  const p = raw || {};
  return {
    ...p,
    id: p.id || p._id || "",
    slug: p.slug || "",
    product_name: p.product_name || p.name || "",
    brand: p.brand || "",
    model: p.model || "",
    category: p.category || "",
    subcategory: p.subcategory || "",
    condition: p.condition || "",
    stock_status: p.stock_status || p.status || "Hubungi Kami",
    short_description: p.short_description || p.description || "",
    featured_image: p.featured_image || "",
    gallery_images: Array.isArray(p.gallery_images) ? p.gallery_images : [],
    specifications: Array.isArray(p.specifications) ? p.specifications : [],
    documents: Array.isArray(p.documents) ? p.documents : [],
    video: p.video || null,
    featured: Boolean(p.featured),
    published: p.published !== false,
  };
}

/** Normalize a taxonomy row (category/brand) with legacy field support.
 *  Older API responses used {category, count} or {brand, count}. */
export function normalizeTaxonomy(raw, fallbackLegacyKey) {
  const t = raw || {};
  return {
    ...t,
    id: t.id || t._id || "",
    name: t.name || (fallbackLegacyKey ? t[fallbackLegacyKey] : "") || "",
    slug: t.slug || "",
    count: typeof t.count === "number" ? t.count : 0,
  };
}
